import SVGImage from '~/components/Image/SVGImage'
import { TopicId } from '~/dashboard/utils/learningPath.utils'
import useOraclePrompt from '~/aioracle/hooks/useOraclePrompt'
import { CATEGORY_COLORS } from '~/bootcamp/constants/bootcamp.const'

import AiIcon from './AiIcon'

export default function AiLevel({
  curriculumLevelId,
  levelTitle,
  isCompleted,
  topic,
  prompt,
  onClick,
  handleGradeLevelAnalytics,
}: {
  curriculumLevelId: string
  prompt: string
  levelTitle: string
  isCompleted: boolean
  topic: TopicId
  onClick: (title: string) => void
  handleGradeLevelAnalytics: ({
    gradeLevelType,
    gradeLevelTitle,
    aiPrompt,
  }: {
    gradeLevelType: 'bootcamp' | 'ai_prompt'
    gradeLevelTitle: string
    aiPrompt?: string
  }) => void
}): React.ReactElement {
  const borderColorClass = CATEGORY_COLORS[topic]?.borderClass
  const sendToOracleAI = useOraclePrompt()

  const onClickPrompt = (): void => {
    sendToOracleAI(levelTitle, prompt, { isCurriculum: true }, curriculumLevelId, isCompleted)
    handleGradeLevelAnalytics({ gradeLevelType: 'ai_prompt', gradeLevelTitle: levelTitle, aiPrompt: prompt })
    onClick(levelTitle)
  }

  return (
    <button className="flex w-full" onClick={() => onClickPrompt()}>
      {isCompleted ? (
        <div className="mx-auto relative flex rounded w-full p-2.5 h-fit border-white border bg-purple-darker text-white">
          <SVGImage className="my-auto min-w-12" height={34} srcKey="bootcamp/checkmark-white-border.svg" width={34} />
          <div className="absolute -top-5 -left-6">
            <AiIcon />
          </div>
          <p className="text-base tracking-px text-left">{levelTitle}</p>
        </div>
      ) : (
        <div className={`mx-auto flex space-x-2.5 border-4 rounded w-full p-1 bg-white h-fit ${borderColorClass}`}>
          <AiIcon />
          <p className="text-base tracking-px py-1.5 text-left">{levelTitle}</p>
        </div>
      )}
    </button>
  )
}
